import { firebaseClient } from "../firebaseClient";
import async from 'async';



export const getCollection = async (name) => {
    // console.log("getList: " + idList);
    const db = firebaseClient.firestore();

    let tweets = [];
    try {

        let bookmarkDocs: any = [];

        if (name) {
            console.log("getCollection for " + name);
            bookmarkDocs = await db.collection("staticTweets").where("category", "==", name).get();
            // const bookmarkDocs = await db.collection("staticTweets").limit(10).get();
        }
        else {
            bookmarkDocs = await db.collection("staticTweets").get();
        }

        bookmarkDocs.forEach((tw) => {
            let data: any = tw.data();
            
            if (!data.sensitive) {
                if (data?.created_at?.toDate) 
                    data.created_at = data.created_at.toDate();
                // @ts-ignore
                tweets.push(data);
            }
        });
    }
    catch (e) {
        console.log("Error in getCollection: " + e.message, e);
    }

    shuffleArray(tweets);
    // tweets = tweets.slice(0, 40);

    // console.log("getList nb tweets got: " + tweets.length);

    return tweets;
};

function shuffleArray (a) {
    var j, x, i;
    for (i = a.length - 1; i > 0; i--) {
        j = Math.floor(Math.random() * (i + 1));
        x = a[i];
        a[i] = a[j];
        a[j] = x;
    }
    return a;
}
